import { useCallback, useEffect, useRef, useState } from 'react';

// Value that only updates after the user stops typing for `ms`.
export const useDebounced = (value, ms = 250) => {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => setV(value), ms); return () => clearTimeout(t); }, [value, ms]);
  return v;
};

// Call before each search request; the returned check is true only for the newest one,
// so a slow older answer can't overwrite the results of what was typed last.
export const useLatestRequest = () => {
  const seq = useRef(0);
  return useCallback(() => { const id = ++seq.current; return () => id === seq.current; }, []);
};
